export const themeMappings = {
  light: {
    'color-basic-black': 'var(--primitives-color-basic-black)',
    'color-basic-white': 'var(--primitives-color-basic-white)',
    'color-alphalight-100': 'var(--primitives-color-alphalight-100)',
    'color-alphalight-200': 'var(--primitives-color-alphalight-200)',
    'color-alphalight-300': 'var(--primitives-color-alphalight-300)',
    'color-alphalight-400': 'var(--primitives-color-alphalight-400)',
    'color-alphalight-500': 'var(--primitives-color-alphalight-500)',
    'color-alphalight-700': 'var(--primitives-color-alphalight-700)',
    'color-gray-100': 'var(--primitives-color-gray-100)',
    'color-gray-200': 'var(--primitives-color-gray-200)',
    'color-gray-300': 'var(--primitives-color-gray-300)',
    'color-gray-400': 'var(--primitives-color-gray-400)',
    'color-gray-500': 'var(--primitives-color-gray-500)',
    'color-gray-600': 'var(--primitives-color-gray-600)',
    'color-gray-700': 'var(--primitives-color-gray-700)',
    'color-gray-800': 'var(--primitives-color-gray-800)',
    'color-gray-900': 'var(--primitives-color-gray-900)',
    'color-gray-1000': 'var(--primitives-color-gray-1000)',
    'color-gray-1200': 'var(--primitives-color-gray-1200)',
    'color-gray-1600': 'var(--primitives-color-gray-1600)',
    'color-green-100': 'var(--primitives-color-green-100)',
    'color-green-300': 'var(--primitives-color-green-300)',
    'color-green-400': 'var(--primitives-color-green-400)',
    'color-green-900': 'var(--primitives-color-green-900)',
    'color-green-1000': 'var(--primitives-color-green-1000)',
    'color-green-1100': 'var(--primitives-color-green-1100)',
    'color-green-1200': 'var(--primitives-color-green-1200)',
    'color-orange-200': 'var(--primitives-color-orange-200)',
    'color-orange-300': 'var(--primitives-color-orange-300)',
    'color-orange-400': 'var(--primitives-color-orange-400)',
    'color-orange-500': 'var(--primitives-color-orange-500)',
    'color-orange-900': 'var(--primitives-color-orange-900)',
    'color-orange-1100': 'var(--primitives-color-orange-1100)',
    'color-purple-200': 'var(--primitives-color-purple-200)',
    'color-purple-300': 'var(--primitives-color-purple-300)',
    'color-purple-400': 'var(--primitives-color-purple-400)',
    'color-purple-500': 'var(--primitives-color-purple-500)',
    'color-purple-600': 'var(--primitives-color-purple-600)',
    'color-purple-900': 'var(--primitives-color-purple-900)',
    'color-purple-1000': 'var(--primitives-color-purple-1000)',
    'color-purple-1100': 'var(--primitives-color-purple-1100)',
    'color-red-200': 'var(--primitives-color-red-200)',
    'color-red-300': 'var(--primitives-color-red-300)',
    'color-red-400': 'var(--primitives-color-red-400)',
    'color-red-600': 'var(--primitives-color-red-600)',
    'color-red-900': 'var(--primitives-color-red-900)',
    'color-red-1000': 'var(--primitives-color-red-1000)',
    'color-red-1300': 'var(--primitives-color-red-1300)',
    'color-special-background-app': 'var(--primitives-color-gray-200)',
    'color-special-content-select-button-primary': 'var(--primitives-color-basic-white)',
    'color-special-content-button-primary-black': 'var(--primitives-color-basic-white)',
    'color-special-background-button-medium-secondary': 'var(--primitives-color-basic-white)',
    'color-special-background-button-medium-secondary-hover': 'var(--primitives-color-gray-200)',
    'color-special-background-button-medium-secondary-pressed': 'var(--primitives-color-gray-300)',
    'color-special-background-button-red-primary': 'var(--primitives-color-red-900)',
    'color-special-background-button-red-primary-hover': 'var(--primitives-color-red-1000)',
    'color-special-background-button-red-primary-pressed': 'var(--primitives-color-red-1100)',
    'color-special-background-button-red-secondary': 'var(--primitives-color-red-300)',
    'color-special-background-button-red-secondary-hover': 'var(--primitives-color-red-400)',
    'color-special-background-button-red-secondary-pressed': 'var(--primitives-color-red-500)',
    'color-special-background-button-purple': 'var(--primitives-color-purple-900)',
    'color-special-background-button-purple-hover': 'var(--primitives-color-purple-1000)',
    'color-special-background-button-purple-pressed': 'var(--primitives-color-purple-1100)',
    'color-special-background-button-switch': 'var(--primitives-color-basic-white)',
    'color-special-background-button-tokens': 'rgba(255,255,255,0.9)',
    'color-special-background-homepage': 'var(--primitives-color-basic-white)',
    'color-special-background-modal': 'var(--primitives-color-basic-white)',
    'color-special-background-navbar': 'rgba(255,255,255,0.7)',
    'color-special-background-overlay': 'rgba(30,31,37,0.08)',
    'color-special-background-tooltip': 'var(--primitives-color-basic-white)',
    'color-special-background-card': 'var(--primitives-color-basic-white)',
    'color-special-border-avatar': 'rgba(0,0,0,0.12)',
    'color-special-border-avatar-mask': 'var(--primitives-color-basic-white)',
    'color-special-border-button-tokens': 'rgba(255,255,255,0.7)',
    'color-special-border-card': 'var(--primitives-color-gray-300)',
    'color-special-border-divider': 'var(--primitives-color-gray-300)',
    'color-special-xchain-stroke': '#162456',
    'color-special-border-button-red-secondary-focus': 'var(--primitives-color-red-400)',
    'color-special-content-button-tokens': 'rgba(0,0,0,0.5)',
    'color-special-content-button-purple': 'var(--primitives-color-basic-white)',
    'color-special-content-pill-tokens': 'rgba(0,0,0,0.12)',
    'color-special-content-button-red-primary-disabled': 'var(--primitives-color-red-600)',
    'color-special-content-button-red-secondary-disabled': 'var(--primitives-color-red-600)',
    'color-special-mb-success-start-color': 'var(--primitives-color-green-900)',
    'color-special-mb-info-color': 'var(--primitives-color-purple-900)',
    'shadow-05': '0px0px0px1pxrgba(0,0,0,0.06),0px2px3pxrgba(0,0,0,0.06)',
    'shadow-10': '0px1px3pxrgba(0,0,0,0.04)',
    'shadow-15': '0px1px2pxrgba(0,0,0,0.2)',
    'inner-shadow-05': '0px0px0px1pxrgba(0,0,0,0.02)inset',
    'inner-shadow-10': '0px0px0px1pxrgba(0,0,0,0.12)inset',
    'gradient-special-homepage':
      'linear-gradient(180deg,rgba(97,202,133,0.04)0%,rgba(97,202,133,0)20.34%)',
    'gradient-active-lscore':
      'linear-gradient(90deg,rgba(247,247,248,0)0%,#f7f7f810%,#f7f7f890%,rgba(247,247,248,0)100%)',
    'gradient-modal-badge-bg': 'linear-gradient(5deg,rgba(255,255,255,0.38)-2.19%,#fff64.44%)',
    'gradient-xchain-pending-token':
      'linear-gradient(-85.03deg,rgba(255,255,255,0.38)0%,white100%)',
  },
  dark: {
    'color-alphalight-100': 'var(--primitives-color-alphadark-1400)',
    'color-alphalight-200': 'var(--primitives-color-alphadark-1300)',
    'color-alphalight-300': 'var(--primitives-color-alphadark-1200)',
    'color-alphalight-400': 'var(--primitives-color-alphadark-1100)',
    'color-alphalight-500': 'var(--primitives-color-alphadark-1000)',
    'color-alphalight-700': 'var(--primitives-color-alphadark-800)',
    'color-gray-100': 'var(--primitives-color-gray-1600)',
    'color-gray-200': 'var(--primitives-color-gray-1200)',
    'color-gray-300': 'var(--primitives-color-gray-1100)',
    'color-gray-400': 'var(--primitives-color-gray-1000)',
    'color-gray-500': 'var(--primitives-color-gray-900)',
    'color-gray-600': 'var(--primitives-color-gray-800)',
    'color-gray-700': 'var(--primitives-color-gray-700)',
    'color-gray-800': 'var(--primitives-color-gray-600)',
    'color-gray-900': 'var(--primitives-color-gray-500)',
    'color-gray-1000': 'var(--primitives-color-gray-500)',
    'color-gray-1200': 'var(--primitives-color-gray-400)',
    'color-gray-1600': 'var(--primitives-color-gray-100)',
    'color-green-100': 'var(--primitives-color-green-1600)',
    'color-green-300': 'var(--primitives-color-green-1600)',
    'color-green-400': 'var(--primitives-color-green-1500)',
    'color-green-900': 'var(--primitives-color-green-800)',
    'color-green-1000': 'var(--primitives-color-green-900)',
    'color-green-1100': 'var(--primitives-color-green-600)',
    'color-green-1200': 'var(--primitives-color-green-700)',
    'color-orange-200': 'var(--primitives-color-orange-1600)',
    'color-orange-300': 'var(--primitives-color-orange-1600)',
    'color-orange-400': 'var(--primitives-color-orange-1500)',
    'color-orange-500': 'var(--primitives-color-orange-1400)',
    'color-orange-900': 'var(--primitives-color-orange-800)',
    'color-orange-1100': 'var(--primitives-color-orange-600)',
    'color-purple-200': 'var(--primitives-color-purple-1600)',
    'color-purple-300': 'var(--primitives-color-purple-1600)',
    'color-purple-400': 'var(--primitives-color-purple-1300)',
    'color-purple-500': 'var(--primitives-color-purple-1600)',
    'color-purple-600': 'var(--primitives-color-purple-700)',
    'color-purple-900': 'var(--primitives-color-purple-700)',
    'color-purple-1000': 'var(--primitives-color-purple-800)',
    'color-purple-1100': 'var(--primitives-color-purple-400)',
    'color-red-200': 'var(--primitives-color-red-1600)',
    'color-red-300': 'var(--primitives-color-red-1600)',
    'color-red-400': 'var(--primitives-color-red-1500)',
    'color-red-600': 'var(--primitives-color-red-700)',
    'color-red-900': 'var(--primitives-color-red-700)',
    'color-red-1000': 'var(--primitives-color-red-500)',
    'color-red-1300': 'var(--primitives-color-red-600)',
    'color-special-background-app': 'var(--primitives-color-gray-1500)',
    'color-special-background-button-medium-secondary': 'rgba(196,204,244,0.18)',
    'color-special-background-button-medium-secondary-hover': 'rgba(205,209,250,0.25)',
    'color-special-background-button-medium-secondary-pressed': 'rgba(204,208,251,0.29)',
    'color-special-content-select-button-primary': 'var(--primitives-color-basic-white)',
    'color-special-content-button-primary-black': 'var(--primitives-color-gray-1600)',
    'color-special-background-button-red-primary': 'var(--primitives-color-red-800)',
    'color-special-background-button-red-primary-hover': 'var(--primitives-color-red-700)',
    'color-special-background-button-red-primary-pressed': 'var(--primitives-color-red-600)',
    'color-special-background-button-red-secondary': 'var(--primitives-color-red-1400)',
    'color-special-background-button-red-secondary-hover': 'var(--primitives-color-red-1300)',
    'color-special-background-button-red-secondary-pressed': 'var(--primitives-color-red-1200)',
    'color-special-background-button-purple': 'var(--primitives-color-purple-900)',
    'color-special-background-button-purple-hover': 'var(--primitives-color-purple-800)',
    'color-special-background-button-purple-pressed': 'var(--primitives-color-purple-700)',
    'color-special-background-button-switch': 'var(--primitives-color-gray-1300)',
    'color-special-background-button-tokens': 'rgba(37,38,46,0.78)',
    'color-special-background-homepage': 'var(--primitives-color-gray-1500)',
    'color-special-background-modal': 'var(--primitives-color-gray-1300)',
    'color-special-background-navbar': 'rgba(30,31,37,0.7)',
    'color-special-background-overlay': 'rgba(30,31,37,0.4)',
    'color-special-background-tooltip': 'var(--primitives-color-gray-1100)',
    'color-special-background-card': 'rgba(175,188,230,0.08)',
    'color-special-border-avatar': 'rgba(255,255,255,0.1)',
    'color-special-border-avatar-mask': 'var(--primitives-color-gray-1300)',
    'color-special-border-button-tokens': 'rgba(37,38,46,0.4)',
    'color-special-border-card': 'rgba(175,188,230,0.08)',
    'color-special-border-divider': 'var(--primitives-color-gray-900)',
    'color-special-xchain-stroke': 'var(--primitives-color-basic-white)',
    'color-special-border-button-red-secondary-focus': 'var(--primitives-color-red-1300)',
    'color-special-content-button-tokens': 'rgba(255,255,255,0.8)',
    'color-special-content-pill-tokens': 'rgba(255,255,255,0.4)',
    'color-special-content-button-purple': 'var(--primitives-color-basic-white)',
    'color-special-content-button-red-primary-dis': 'var(--primitives-color-red-600)',
    'color-special-content-button-red-secondary-dis': 'var(--primitives-color-red-1100)',
    'color-special-mb-success-start-color': 'var(--primitives-color-green-800)',
    'color-special-mb-info-color': 'var(--primitives-color-purple-700)',
    'shadow-10': '0px1px3pxrgba(0,0,0,0.04)',
    'shadow-15': '0px1px2pxrgba(0,0,0,0.2)',
    'shadow-30': '0px0px0px1px#393a46inset',
    'inner-shadow-05': '0px0px0px1pxrgba(255,255,255,0.04)inset',
    'inner-shadow-10': '0px0px0px1pxrgba(255,255,255,0.1)inset',
    'shadow-modal-badge': "''",
    'gradient-special-homepage':
      'linear-gradient(180deg,rgba(97,202,133,0.08)0%,rgba(97,202,133,0)20.34%)',
    'gradient-active-lscore':
      'linear-gradient(90deg,rgba(175,188,230,0)0%,rgba(175,188,230,0.08)10%,rgba(175,188,230,0.08)90%,rgba(175,188,230,0)100%)',
    'gradient-modal-badge-bg':
      'linear-gradient(5deg,rgba(77,78,94,0.2)-2.19%,rgba(77,78,94,0.7)64.44%)',
    'gradient-xchain-pending-token':
      'linear-gradient(-85.03deg,rgba(77,78,94,0.2)0%,rgba(77,78,94,0.7)100%)',
  },
};
